import { render, staticRenderFns } from "./UserRegistrationSuccess.vue?vue&type=template&id=dc538138&"
import script from "./UserRegistrationSuccess.vue?vue&type=script&lang=ts&"
export * from "./UserRegistrationSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./UserRegistrationSuccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports